/**
 * Longest a patient name can plausibly be. Measured against all 56,098 active
 * patients: the longest full name is 25 characters and none runs to more than
 * three words, so anything past these is prose, not a name.
 */
const MAX_NAME_LENGTH = 30;
const MAX_NAME_WORDS = 3;

/**
 * True when the input is long enough to be a question rather than a patient
 * identifier, so the type-ahead can stay silent instead of searching for each of
 * "who got critical alerts yesterday" in turn, and Enter sends it to AI Search.
 *
 * Deliberately permissive: a three-word name still gets searched, because
 * suppressing a lookup that would have found someone is a worse failure than one
 * wasted request.
 */
export const looksLikePrompt = (raw: string): boolean => {
  const term = raw.trim();
  if (term.length > MAX_NAME_LENGTH) return true;

  return term.split(/\s+/).filter(Boolean).length > MAX_NAME_WORDS;
};
